module.exports = __webpack_public_path__ + "operace-previsleho-bricha-abdominoplastika_11_after_tn.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures_tn/plasticka-chirurgie/operace-previsleho-bricha-abdominoplastika_11_after_tn.jpg
// module id = 1645
// module chunks = 0